var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStepIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 32,
    viewBox: "0 0 18 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 5 Copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.93475 23.5937C2.83339 26.8178 4.28522 30.1137 8.23988 30.1137C12.1945 30.1137 13.6464 26.8178 14.545 23.5937C14.6583 23.1873 14.5507 22.7583 14.253 22.4296C13.9554 22.101 13.5007 21.9092 13.0193 21.9092H3.46046C2.97907 21.9092 2.52436 22.101 2.22673 22.4296C1.9291 22.7583 1.82141 23.1874 1.93475 23.5937ZM8.23987 27.3865C7.63842 27.3865 6.59553 27.3865 5.53496 24.6365H10.945C9.88444 27.3865 8.84155 27.3865 8.2401 27.3865H8.23998H8.23987Z",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.765074 17.9893C0.876108 18.6606 1.53824 19.1591 2.31893 19.1591H14.1613C14.9421 19.1591 15.6042 18.6606 15.7151 17.9893C15.8522 17.16 15.9911 16.256 16.1396 15.2258V15.2256C17.0283 9.05291 16.1759 4.64082 13.6062 2.11209C12.2021 0.730364 10.3465 0 8.2401 0C6.13368 0 4.27811 0.730364 2.874 2.11209C0.304295 4.64082 -0.548089 9.05282 0.340608 15.2258C0.489527 16.2585 0.628399 17.1625 0.765074 17.9893ZM13.0243 14.8869C12.9452 15.4361 12.8689 15.9484 12.7942 16.4318H3.68599C3.61148 15.9491 3.53519 15.4368 3.45586 14.8871C2.70562 9.67564 3.33489 5.77964 5.22771 3.91691C6.02986 3.12755 7.04341 2.72727 8.2401 2.72727C9.43678 2.72727 10.4503 3.12755 11.2525 3.91691C13.1453 5.77964 13.7746 9.67564 13.0243 14.8869Z",
    fill: "#979797"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStepIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/stepIcon.b374aeb2f569fc5523b211413172bff5.svg";